import React from 'react';
import ChatPage from '../../components/WhatsAppChat/ChatPage';

export default function WhatsAppChatPage() {
  return (
    <div className="h-full">
      <ChatPage />
    </div>
  );
}
